<template>
    <div>
        <!--面包屑-->
        <p class="breadcrumb">MANAGE TEACHERS</p>
        <!--上方操作框-->
        <el-row type="flex" class="row-bg p-10 mt-10 bg-lightgarg" justify="space-between">
            <el-col :span="8">
                <el-input class="input-setMaxWidth" placeholder="Search anything about users" v-model="message" @keyup.enter.native="handleIconClick">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="handleIconClick"></i>
                </el-input>
            </el-col>
            <el-col :span="16" class="text-right">
                <el-button type="success" @click="Creatdialog = true" icon="el-icon-plus">New Teacher</el-button>
            </el-col>
        </el-row>
        <!--下方表格-->
        <el-table empty-text="No data" :data="users" border v-loading="loading" element-loading-text="loading..." style="width: 100%" class="mt-20">
            <el-table-column label="Name" min-width="250">
                <template slot-scope="scope">
                    <span>{{scope.row.displayName + ' - ' + scope.row.givenName + '  ' +  scope.row.familyName}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="email" label="Email" min-width="250"></el-table-column>
            <el-table-column prop="action" label="Actions" width="130" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" icon="el-icon-edit" @click="EditUser(scope.row)"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-delete" @click="TrashTeacher(scope.row)"></el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页符-->
        <div class="text-center mt-20 mb-50">
            <el-pagination layout="prev, pager, next" :page-size="size" :current-page="currentPage" :page-count="totalPages"
                           @current-change="pageCurrentChange">
            </el-pagination>
        </div>

        <!--新建老师-->
        <el-dialog title="New Teacher" :visible.sync="Creatdialog" customClass="dialogStyle">
            <el-form :model="Newform" :rules="Newrules" ref="Newform" label-width="145px">
                <el-form-item label="Email Address" prop="Nemail">
                    <el-input v-model="Newform.Nemail" placeholder="Email Address" ></el-input>
                </el-form-item>
                <el-form-item label="Password" prop="Npassword">
                    <el-input type="password" v-model="Newform.Npassword" placeholder="Password should contain 8 to 20 characters." ></el-input>
                </el-form-item>
                <el-form-item label="Confirm Password" prop="NconfirmPassword">
                    <el-input type="password" v-model="Newform.NconfirmPassword" placeholder="Confirm Password" ></el-input>
                </el-form-item>
                <el-form-item label="Given Name" prop="NgivenName">
                    <el-input v-model="Newform.NgivenName" placeholder="Given Name" ></el-input>
                </el-form-item>
                <el-form-item label="Family Name" prop="NfamilyName">
                    <el-input v-model="Newform.NfamilyName" placeholder="Family Name" ></el-input>
                </el-form-item>
                <el-form-item label="Display Name" prop="NdisplayName">
                    <el-input v-model="Newform.NdisplayName" placeholder="Display Name" ></el-input>
                </el-form-item>
                <el-form-item label="Mobile Phone" prop="NmobilePhone">
                    <el-input v-model="Newform.NmobilePhone" placeholder="Mobile Phone" ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="Creatdialog = false">Close</el-button>
                <el-button type="primary" @click="NewTeacher('Newform')" :loading="ntSaveBtnIsLoading">Save</el-button>
            </div>
        </el-dialog>

        <!--修改老师-->
        <el-dialog title="Edit User" :visible.sync="Editdialog" customClass="dialogStyle">
            <el-form :model="editform" :rules="editrules" ref="editform" label-width="145px">
                <el-form-item label="Email Address" prop="Eemail">
                    <el-input v-model="editform.Eemail" placeholder="Email Address" auto-complete="off" value="ccccc"></el-input>
                </el-form-item>
                <el-form-item label="Change Password" prop="checked">
                    <el-checkbox v-model="checked" @change="changePass" >Change Password</el-checkbox>
                </el-form-item>
                <template v-if="willshow">
                    <el-form-item label="Password" prop="Epassword">
                        <el-input type="password" v-model="editform.Epassword" placeholder="Password should contain 8 to 20 characters." ></el-input>
                    </el-form-item>
                    <el-form-item label="Confirm Password" prop="EconfirmPassword">
                        <el-input type="password" v-model="editform.EconfirmPassword" placeholder="Confirm Password"></el-input>
                    </el-form-item>
                </template>
                <el-form-item label="Given Name" prop="EgivenName">
                    <el-input v-model="editform.EgivenName" placeholder="Given Name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Family Name" prop="EfamilyName">
                    <el-input v-model="editform.EfamilyName" placeholder="Family Name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Display Name" prop="EdisplayName">
                    <el-input v-model="editform.EdisplayName" placeholder="Display Name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Mobile Phone" prop="EmobilePhone">
                    <el-input v-model="editform.EmobilePhone" placeholder="Mobile Phone" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="Editdialog = false">Close</el-button>
                <el-button type="primary" @click="submitedit('editform')" :loading="ctSaveBtnIsLoading">Save</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
    import md5 from '../../component/md5'
    export default {
        data() {
            //新建用户信息密码自动验证
            var NewPass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Password Required'));
                } else {
                    if (this.Newform.NconfirmPassword !== '') {
                        this.$refs.Newform.validateField('NconfirmPassword');
                    }
                    callback();
                }
            };
            var NewPass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('ConfirmPassword Required'));
                } else if (value !== this.Newform.Npassword) {
                    callback(new Error('Passwords do not match!'));
                } else {
                    callback();
                }
            };

            //修改用户信息密码自动验证
            var EditPass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Password Required'));
                } else {
                    if (this.editform.EconfirmPassword !== '') {
                        this.$refs.editform.validateField('EconfirmPassword');
                    }
                    callback();
                }
            };
            var EditPass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('ConfirmPassword Required'));
                } else if (value !== this.editform.Epassword) {
                    callback(new Error('Passwords do not match!'));
                } else {
                    callback();
                }
            };

            return {
                activeIndex2: '1',
                LoginName: 'Admin',//登录用户名

                //搜索栏
                message: '',
                selecttripvalue: '',//老师端没有这个值，但是统一借口需要传
                role: 'ta',//teacher代表未查看老师列表
                trashed: 0,//0代表未删除学生

                users: [],
                currentPage: 1,
                size: 15,
                totalPages: 1,
                // loading过渡状态变量
                loading: true,
                ntSaveBtnIsLoading: false,
                ctSaveBtnIsLoading: false,

                //新建老师
                Creatdialog: false,
                Newform: {},
                Newrules: {
                    Nemail: [
                        {required: true, message: 'Email Adress Required', trigger: 'blur'},
                        {type: 'email', message: 'Email format invalid.'},
                    ],
                    Npassword: [
                        {required: true, message: 'Password Required', trigger: 'blur'},
                        {validator: NewPass, trigger: 'blur'},
                        {min: 8, max: 20, message: 'Password should contain 8 to 20 characters.', trigger: 'blur'},
                        {pattern: /^\w{8,20}$/, message: "Only numbers, letters, and underscores allowed.", trigger: 'blur'}
                    ],
                    NconfirmPassword: [
                        {required: true, message: 'ConfirmPassword Required', trigger: 'blur'},
                        {validator: NewPass2, trigger: 'blur'},
                    ],
                    NgivenName: [
                        {required: true, message: 'GivenName Required', trigger: 'blur'},
                        {max: 30, message: 'givenName should not more than 30 characters.', trigger: 'blur'}
                    ],
                    NfamilyName: [
                        {required: true, message: 'FamilyName Required', trigger: 'blur'},
                        {max: 30, message: 'familyName should not more tha 30 characters.', trigger: 'blur'}
                    ],
                    NdisplayName: [
                        {required: true, message: 'DisplayName Required', trigger: 'blur'},
                        {max: 60, message: 'displayName should not more tha 60 characters.', trigger: 'blur'}
                    ],
                    NmobilePhone: [
                        {required: true, message: 'MobilePhone Required', trigger: 'blur'},
                        {pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur'}
                    ],
                },
                //修改老师弹窗
                checked: false,
                willshow: false,//修改弹窗修密码框是否显示
                Editdialog: false,
                editform: {
                    EdisplayName:'',
                    EfamilyName:'',
                    EgivenName:'',
                    Eemail:'',
                    EmobilePhone:'',
                    Epassword: '',
                    EconfirmPassword: ''
                },
                editrules: {
                    Eemail: [
                        {required: true, message: 'Email Adress Required', trigger: 'blur'},
                        {type: 'email', message: 'Email format invalid.'},
                    ],
                    Epassword: [
                        {required: true, message: 'Password Required', trigger: 'blur'},
                        {validator: EditPass, trigger: 'blur'},
                        {min: 8, max: 20, message: 'Password should contain 8 to 20 characters.', trigger: 'blur'},
                        {pattern: /^\w{8,20}$/, message: "Only numbers, letters, and underscores allowed.", trigger: 'blur'}
                    ],
                    EconfirmPassword: [
                        {required: true, message: 'Confirm Password Required', trigger: 'blur'},
                        {validator: EditPass2, trigger: 'blur'},
                    ],
                    EgivenName: [
                        {required: true, message: 'GivenName Required', trigger: 'blur'},
                        {max: 30, message: 'givenName should not more than 30 characters.', trigger: 'blur'}
                    ],
                    EfamilyName: [
                        {required: true, message: 'FamilyName Required', trigger: 'blur'},
                        {max: 30, message: 'familyName should not more tha 30 characters.', trigger: 'blur'}
                    ],
                    EdisplayName: [
                        {required: true, message: 'DisplayName Required', trigger: 'blur'},
                        {max: 60, message: 'displayName should not more tha 60 characters.', trigger: 'blur'}
                    ],
                    EmobilePhone: [
                        {required: false,},
                        {pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur'}
                    ],
                }
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                this.getusers();
            })
        },
        methods: {
            //输入关键字搜索
            handleIconClick(ev) {
                this.getusers();
            },

            //获取弹窗信息
            EditUser(user){
                this.id = user.id;
                this.editform.EdisplayName = user.displayName;
                this.editform.EfamilyName = user.familyName;
                this.editform.EgivenName = user.givenName;
                this.editform.Eemail = user.email;
                this.editform.EmobilePhone = user.mobilePhone;
                this.Editdialog = true;
                this.checked = false;
                this.willshow = false;
                this.editform.Epassword = '';
                this.editform.EconfirmPassword = '';
            },

            //获取教师列表通用函数
            getusers(){
                this.loading = true;
                this.$http.get('user?' +
                        'role=' + this.role +
                        '&trashed=' + this.trashed +
                        '&page=' + (this.currentPage - 1) +
                        '&tripId=' + this.selecttripvalue +
                        '&keywords=' + this.message)
                    .then(response => {
                        //渲染数据
                        this.users = response.list;
                        this.totalPages = response.totalPages;
                        this.loading = false;
                    }).catch(error => {
                        this.loading = false;
                        this.$message.error(error.message)
                    })
            },

            //改变当前页函数
            pageCurrentChange(val){
                this.currentPage = val;
                this.getusers();
            },

            // 新建老师
            NewTeacher(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.ntSaveBtnIsLoading = true;
                        var Pwd_md5 = md5.hex_md5(this.Newform.Npassword);
                        this.$http.post('teacher', {
                            user: {
                                familyName: this.Newform.NfamilyName,
                                givenName: this.Newform.NgivenName,
                                displayName: this.Newform.NdisplayName,
                                email: this.Newform.Nemail,
                                mobilePhone: this.Newform.NmobilePhone,
                                role: this.role,
                                password: Pwd_md5,
                            }
                        }).then(response => {
                            //渲染数据
                            this.getusers();
                            this.Newform.Nemail = '';
                            this.Newform.Npassword = '';
                            this.Newform.NconfirmPassword = '';
                            this.Newform.NfamilyName = '';
                            this.Newform.NgivenName = '';
                            this.Newform.NdisplayName = '';
                            this.Newform.NmobilePhone = '';
                            this.Creatdialog = false;
                            this.ntSaveBtnIsLoading = false;
                            this.$message.success('New teacher created.');
                        }).catch(error => {
                            this.Creatdialog = false;
                            this.ntSaveBtnIsLoading = false;
                            this.$message.error(error.message)
                        })
                    } else {
                        return false;
                    }
                });
            },

            //修改老师
            changePass(){
                if(this.checked ==true){
                    this.willshow =true;
                    this.isDirty = true;
                }else {
                    this.willshow =false;
                }
            },
            submitedit(form) {
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        this.ctSaveBtnIsLoading = true;
                        var api = {
                            email: this.editform.Eemail,
                            familyName: this.editform.EfamilyName,
                            givenName: this.editform.EgivenName,
                            displayName: this.editform.EdisplayName,
                            mobilePhone: this.editform.EmobilePhone,
                        }
                        if(this.checked == true){
                            var EPwd_md5 = md5.hex_md5(this.editform.Epassword);
                            api.password = EPwd_md5;
                        }
                        this.$http.put('teacher', {
                            id: this.id,
                            user:api
                        }).then(response => {
                            //渲染数据
                            this.getusers();
                            this.Editdialog = false;
                            this.ctSaveBtnIsLoading = false;
                        }).catch(error => {
                            this.loading = false;
                            this.Editdialog = false;
                            this.ctSaveBtnIsLoading = false;
                            this.$message.error(error.message)
                        })
                    } else {
                        return false;
                    }
                });

            },

            //删除老师
            TrashTeacher(user){
                this.deleteName = user.displayName + '-' +user.givenName + '  ' + user.familyName;
                this.email = user.email;
                this.$confirm('Are you sure you want to trash teacher: ' + this.deleteName + ' ' + this.email, 'Trash Teacher', {
                    confirmButtonText: 'Trash',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'el-button--danger',
                    type: 'warning',
                    confirmButtonLoading : false,
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            instance.confirmButtonLoading = true;
                            done();
                        } else {
                            instance.confirmButtonLoading = false;
                            done();
                        }
                    }
                }).then(() => {
                        this.$http.patch('user/trash/' + user.userId).then(response => {
                            this.getusers();
                        }).catch(error => {
                            this.Trashdialog = false;
                            this.$message.error(error.message)
                        })
                    }
                ).catch(() => {//弹窗点击cancel后执行的方法

                });
            },

        }
    }
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// Ta.vue?46a9ffd5